import Splide from "@splidejs/splide";

export default class CollectionsCarouselSlider {
    constructor() {
        this.everyCollectionsCarouselSlider = [];
        this.collectionsCarouselSlider = document.querySelectorAll(
            ".jsCollectionsCarouselSlider"
        );
        this.events();
    }

    events() {
        if (this.collectionsCarouselSlider.length) {
            this.initializeCollectionsCarouselSlider();
        }
    }

    initializeCollectionsCarouselSlider() {
        this.collectionsCarouselSlider.forEach((item) => {
            this.everyCollectionsCarouselSlider.push(
                new Splide(item, {
                    pagination: false,
                    perPage: 1,
                    perMove: 1,
                    arrows: "slider",
                    trimSpace: true,
                    breakpoints: {
                        768: {
                            arrows: false,
                        },
                    },
                }).mount()
            );
        });
    }
}
